import { Component } from 'react';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Layout from './DashboardLayout';
import {
  ClientSearch,
  AddNewClientModal,
  ImportClientModal,
  EditClientModal,
} from '../components/client';
import { clientsService, workSessionService } from '../services';
import Loading from '../components/Loader';
import { NO_DATA } from '../constants';
import { NoDataAlert } from '../components/common';
import { fetchSites } from '../actions/index';

class Clients extends Component {
  state = {
    clientsData: [],
    breaksList: [],
    isLoading: false,
  };

  pageHeading = {
    preTitle: 'Clients',
    title: 'Manage Clients',
  };

  componentDidMount() {
    const { dispatch } = this.props;
    this.getClientsData();
    this.handleGetBreaksList();
    dispatch(fetchSites());
  }

  getClientsData = (payload) => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    clientsService
      .get_clients(
        payload || {
          teamOwnerId: localStorage.getItem('teamOwnerId'),
          status: 'active',
        }
      )
      .then((clientData) => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
        if (clientData.data) {
          this.setState((state) => ({
            ...state,
            clientsData: [...clientData.data],
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handleGetBreaksList = async () => {
    workSessionService
      .get_breaks_list({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
      })
      .then((response) => {
        if (response.data) {
          this.setState((state) => ({
            ...state,
            breaksList: response.data,
          }));
        }
      });
  };

  editClient = (data) => {
    clientsService
      .edit_client({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
        clientId: data.clientId,
        name: data.updatedName,
      })
      .then((response) => {
        if (response.data) {
          this.getClientsData();
        }
      });
  };

  render() {
    const { isLoading, clientsData, breaksList } = this.state;
    return (
      <Layout pageHeading={this.pageHeading}>
        <Row className="mt-2 mb-4 justify-content-between">
          <Col style={{ maxWidth: '300px' }}>
            <ClientSearch updateClientList={this.getClientsData} />
          </Col>
          <Col className="col-auto">
            <ImportClientModal updateClientList={this.getClientsData} />
            <AddNewClientModal
              handleUpdateClientsList={this.getClientsData}
              breaksList={breaksList}
            />
          </Col>
        </Row>

        {clientsData && clientsData.length > 0 && (
          <Row>
            <Col>
              <Card className="px-0">
                <div className="table-responsive">
                  <table className="table table-sm table-hover card-table">
                    <thead>
                      <tr>
                        <th>Client Name</th>
                        <th>Sites</th>
                        <th>Address</th>
                        <th>Website</th>
                        <th>Break Types (* Productive)</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientsData.map((client) => (
                        <tr key={client._id}>
                          <td>
                            <h5 className="m-0">{client.name}</h5>
                          </td>
                          <td>
                            {client.regions?.length > 0 &&
                              client.regions.map((region) => (
                                <p className="m-0" key={region._id}>
                                  {region.siteName}
                                </p>
                              ))}
                          </td>
                          <td>
                            {client.address && (
                              <p className="m-0">
                                {client.address.split('\n').map((str) => (
                                  <>
                                    {str}
                                    <br />
                                  </>
                                ))}
                              </p>
                            )}
                          </td>
                          <td>{client.url && client.url}</td>
                          <td>
                            {client.breakTypes.length > 0 ? (
                              client.breakTypes.map((breakType, index) => (
                                <h4 className="d-inline" key={`${index}-bt`}>
                                  <Badge className="badge bg-secondary-soft me-3">
                                    {breakType.name}
                                    {breakType.shortCode &&
                                    breakType.shortCode !== ''
                                      ? `${' '}(${breakType.shortCode})${' '}`
                                      : ''}{' '}
                                    {breakType.billable && '*'}
                                  </Badge>
                                </h4>
                              ))
                            ) : (
                              <span className="text-muted">
                                No break types available
                              </span>
                            )}
                          </td>
                          <td align="right">
                            <EditClientModal
                              selectedClient={client}
                              handleUpdateClientsList={this.getClientsData}
                              breaksList={breaksList}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Card>
            </Col>
          </Row>
        )}

        {!isLoading && clientsData.length === 0 && (
          <NoDataAlert content={NO_DATA.CLIENTS} displayBorder />
        )}

        {/* Loader */}
        {isLoading && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

Clients.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(Clients);
